import getMonth from './get-month';

export { getMonth };

export default getMonth;
